<template>
    <div class="content">
        <el-form
            :label-position="labelPosition"
            label-width="80px"
            :model="formLabelAlign"
            ref="formLabelAlign"
            :rules="formLabelRules"
        >
            <el-form-item label="新密码" prop="newPassWord">
                <el-input
                    :key="passwordType"
                    ref="password"
                    v-model="formLabelAlign.newPassWord"
                    :type="passwordType"
                    placeholder="请输入密码"
                    name="password"
                    tabindex="2"
                    auto-complete="on"
                    @keyup.enter.native="handleLogin"
                />
                <span class="show-pwd" @click="showPwd">
                    <svg-icon
                        :icon-class="
                            passwordType === 'password' ? 'eye' : 'eye-open'
                        "
                    />
                </span>
            </el-form-item>

            <el-button
                :loading="loading"
                type="primary"
                style="
                    width: 100%;
                    margin-top: 35px;
                    background: #0195ff;
                    box-shadow: 0 2px 9px 0 #0195ff33;
                    border-radius: 8px;
                "
                @click.native.prevent="submit"
                >提交</el-button
            >
        </el-form>
    </div>
</template>

<script>
import { updatePassWord } from '@/api/index'
export default {
    data() {
        return {
            labelPosition: 'top',
            passwordType: 'password',
            formLabelAlign: {
                newPassWord: ''
            },
            formLabelRules: {
                newPassWord: [
                    {
                        required: true,
                        trigger: 'blur',
                        message: '请输入新密码'
                    }
                ]
            }
        }
    },
    methods: {
        showPwd() {
            if (this.passwordType === 'password') {
                this.passwordType = ''
            } else {
                this.passwordType = 'password'
            }
            this.$nextTick(() => {
                this.$refs.password.focus()
            })
        },
        submit() {
            this.$refs.formLabelAlign.validate((valid) => {
                if (valid) {
                    this.loading = true
                    updatePassWord(this.formLabelAlign).then((response) => {
                        this.loading = false
                        console.log(response)
                        if (response.code == 0) {
                            this.$message({
                                message: '修改成功',
                                type: 'success'
                            })
                            this.formLabelAlign = {
                                newPassWord: ''
                            }
                        }
                    })

                    // this.$store
                    //     .dispatch('user/login', this.loginForm)
                    //     .then(() => {
                    //         this.$router.push({ path: this.redirect || '/' })
                    //         this.loading = false
                    //     })
                    //     .catch(() => {
                    //         this.loading = false
                    //     })
                } else {
                    console.log('error submit!!')
                    return false
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
$dark_gray: #889aa4;

.content {
    padding: 30px;
    box-sizing: border-box;
}
.show-pwd {
    position: absolute;
    right: 10px;
    top: 0px;
    font-size: 16px;
    color: $dark_gray;
    cursor: pointer;
    user-select: none;
}
</style>